import { FormFooterAction } from '../../../../shared/components/FormActionsContext';
import React from 'react';
import { Plus, Trash2 } from '../../../../shared/assets/AppIcons';
import { Button } from '@/shared/ui/button';
import { Input } from '@/shared/ui/input';
import { Label } from '@/shared/ui/label';

export default function CreditRowsFieldArray({ rows, onAdd, onRemove, onChange }) {
  return (
    <div className="bg-[var(--success-soft)] p-4 rounded-lg border border-[var(--success-border)]">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold text-[var(--success-text)]">Crediti</h3>
        <FormFooterAction>
          <Button
            type="button"
            className="form-footer-add"
            aria-label="Aggiungi credito"
            title="Aggiungi credito"
            size="sm"
            variant="outline"
            onClick={onAdd}
          >
            <Plus size={16} className="mr-1" />
            Aggiungi Riga
          </Button>
        </FormFooterAction>
      </div>
      <div className="space-y-3">
        {rows.map((row, index) => (
          <div
            key={row.id}
            className="bg-[var(--surface-raised)] p-3 rounded-lg border border-[var(--success-border)]"
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-medium text-[var(--success-text)]">Credito #{index + 1}</span>
              {rows.length > 1 ? (
                <Button
                  type="button"
                  size="sm"
                  variant="ghost"
                  onClick={() => onRemove(row.id)}
                  className="h-6 w-6 p-0 text-[var(--warning-text)]"
                >
                  <Trash2 size={16} />
                </Button>
              ) : null}
            </div>
            <div className="grid grid-cols-5 gap-2">
              <div>
                <Label className="text-xs">Tipo</Label>
                <Input
                  value={row.tipoCredito}
                  onChange={(event) => onChange(row.id, 'tipoCredito', event.target.value)}
                  className="mt-1 h-8 text-xs"
                />
              </div>
              <div>
                <Label className="text-xs">Anno</Label>
                <Input
                  value={row.anno}
                  onChange={(event) => onChange(row.id, 'anno', event.target.value)}
                  className="mt-1 h-8 text-xs"
                />
              </div>
              <div data-form-field="description">
                <Label className="text-xs">Descrizione</Label>
                <Input
                  value={row.descrizione}
                  onChange={(event) => onChange(row.id, 'descrizione', event.target.value)}
                  className="mt-1 h-8 text-xs"
                />
              </div>
              <div>
                <Label className="text-xs">Valore Nominale</Label>
                <Input
                  value={row.valoreNominale}
                  onChange={(event) => onChange(row.id, 'valoreNominale', event.target.value)}
                  className="mt-1 h-8 text-xs"
                />
              </div>
              <div>
                <Label className="text-xs">Prezzo Acquisto</Label>
                <Input
                  value={row.prezzoAcquisto}
                  onChange={(event) => onChange(row.id, 'prezzoAcquisto', event.target.value)}
                  className="mt-1 h-8 text-xs"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
